export default (props, e) => {
  const target = e.target.getAttribute('href');
  history.replaceState( {} , '', target);
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/replaceHistory.js